<template>
  <div id="app">
    <!-- <keep-alive :include="['Webgl']">
      <router-view v-if="isRouterAlive" />
    </keep-alive> -->

    <keep-alive>
      <router-view  v-if="$route.name === 'webgl'"></router-view>
    </keep-alive>
    <router-view  v-if="$route.name !== 'webgl' & isRouterAlive"></router-view>
    
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue